import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerJourneyRoutingModule } from './customer-journey.routing.module';
import { InsuredDetailComponent } from './pages/insured-detail/insured-detail.component';
import { CustomerJourneyComponent } from './customer-journey.component';
import { LayoutModule } from '../layout/layout.module';
import { PolicyCalanderComponent } from './components/policy-calander/policy-calander.component';
import { ContactDetailComponent } from './pages/contact-detail/contact-detail.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimaryInsuredDobComponent } from './components/primary-insured-dob/primary-insured-dob.component';
import { AdditionalInsuredDobComponent } from './components/additional-insured-dob/additional-insured-dob.component';
import { SharedModule } from '../shared/shared.module';
import { RasAyudaModule } from 'ras-ayuda';
import { CaptchaV3Component } from './components/captcha-v3/captcha-v3/captcha-v3.component';

@NgModule({
  declarations: [
    InsuredDetailComponent,
    ContactDetailComponent,
    CustomerJourneyComponent,
    PolicyCalanderComponent,
    PrimaryInsuredDobComponent,
    AdditionalInsuredDobComponent,
    CaptchaV3Component
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, CustomerJourneyRoutingModule, LayoutModule, SharedModule, RasAyudaModule]
})
export class CustomerJourneyModule {}
